import { Radio } from "../components/Radio";
import { Checkbox } from "../components/Checkbox";
import { ButtonToggle } from "../components/ButtonToggle";

export const PROPERTY_FILTERS_COMPONENT_MAP = {
  deals: Radio,
  star: ButtonToggle,
  price: Checkbox,
  lodging: Checkbox,
  amenities: Checkbox,
  regionId: Radio,
  travelerType: Checkbox,
  poi: Radio,
  popularFilter: Checkbox,
  guestRating: Radio,
  accessibility: Checkbox,
  paymentType: Checkbox,
  bedroomFilter: Radio,
  propertyStyle: Checkbox,
  commissionTier: Radio,
  mealPlan: Checkbox,
};
